export default {
  AUD: '$ ',
  USD: '$ ',
  RUR: '₽ ',
  RUB: '₽ ',
  CAD: '$ ',
  EUR: '€ ',
  CNY: '¥ ',
  JPY: '¥ ',
  GBP: '£ ',
  UAH: '₴ ',
  KRW: '₩ ',
  THB: '฿ ',
  VND: '₫ ',
  PHP: '₱ ',
  PLN: 'zł ',
  IDR: 'Rp ',
  INR: '₹ ',
  SGD: 'S$ ',
  BRL: 'R$ ',
  MYR: 'RM ',
  MXN: '$ ',
  ILS: '₪ ',
  HUF: 'Ft ',
  SEK: 'Kr ',
  NPR: 'N₨ ',
  LKR: 'Re ',
  BDT: 'Tk ',
  PKR: 'Rs ',
  TWD: 'NT$ ',
  DKK: 'kr ',
  NOK: 'NKr ',
  PYG: '₲ ',
} as {[type: string]: string};

export const enum CurrencyOrderSizeEnum {
  normal = 1,
  large
}

export const currencyOrderSizeEnum = {
  normal: CurrencyOrderSizeEnum.normal,
  large: CurrencyOrderSizeEnum.large
}
export interface CurrencyOrder {
  code: string;
  size: CurrencyOrderSizeEnum;
}

export interface CurrencyOrderIndexed extends  CurrencyOrder{
  index: number;
}

export const order: CurrencyOrder[] = [
  {
    code: 'USD',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'EUR',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'RUR',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'RUB',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'CAD',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'AUD',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'GBP',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'CNY',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'JPY',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'UAH',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'THB',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'VND',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'PHP',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'INR',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'PLN',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'KRW',
    size: CurrencyOrderSizeEnum.normal,
  },
  {
    code: 'IDR',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'SGD',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'BRL',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'MYR',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'MXN',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'ILS',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'HUF',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'SEK',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'NPR',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'LKR',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'BDT',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'PKR',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'TWD',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'DKK',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'NOK',
    size: CurrencyOrderSizeEnum.large,
  },
  {
    code: 'PYG',
    size: CurrencyOrderSizeEnum.large,
  }
];

let pOrderIndex: {[type: string]: CurrencyOrderIndexed } = {};

order.forEach((item, index) => {
  pOrderIndex[item.code] = {
    ...item,
    index: index
  };
})

export interface currency {
  code:string;
  name:string;
}

export interface currencyFull {
  code:string;
  name:string;
  index:number;
  sign:string;
  size:string;
}

export const orderIndex = pOrderIndex;
